import {AppRoutes, LocalStorageKeys} from "../utils/constants";
import {useNotifyEventsService} from "../services/notify-events-service";

const defaultIntendedUrl = AppRoutes.landing.path;

export const getToken = () => window.localStorage.getItem(LocalStorageKeys.AuthToken);
export const setToken = token => {
  token
    ? window.localStorage.setItem(LocalStorageKeys.AuthToken, token)
    : window.localStorage.removeItem(LocalStorageKeys.AuthToken);
};

export const getShowTrainerMessage = () => {
  let u = window.localStorage.getItem(LocalStorageKeys.ShowTrainerMessage);
  return u ? JSON.parse(u) : null;
}
export const setShowTrainerMessage = message => {
  window.localStorage.setItem(LocalStorageKeys.ShowTrainerMessage, JSON.stringify(message));
};

export const getUnreadInboxMessagesCount = () => {
  let u = window.localStorage.getItem(LocalStorageKeys.UnreadMessagesCount);
  return u ? JSON.parse(u) : null;
}
export const setUnreadInboxMessagesCount = message => {
  window.localStorage.setItem(LocalStorageKeys.UnreadMessagesCount, JSON.stringify(message));
};

export const getSearchFilter = () => {
  let u = window.localStorage.getItem(LocalStorageKeys.Filter);
  return u ? JSON.parse(u) : null;
}
export const setSearchFilter = filter => {
  filter
      ? window.localStorage.setItem(LocalStorageKeys.Filter, JSON.stringify(filter))
      : window.localStorage.removeItem(LocalStorageKeys.Filter);
};

export const getUserData = () => {
  let u = window.localStorage.getItem(LocalStorageKeys.UserData);
  return u ? JSON.parse(u) : null;
}
export const setUserData = user => {
  user
      ? window.localStorage.setItem(LocalStorageKeys.UserData, JSON.stringify(user))
      : window.localStorage.removeItem(LocalStorageKeys.UserData);
};

export const getIntendedUrl = () => window.localStorage.getItem(LocalStorageKeys.IntendedUrl) || defaultIntendedUrl;

export const setIntendedUrl = url => {
  url
    ? window.localStorage.setItem(LocalStorageKeys.IntendedUrl, url)
    : window.localStorage.removeItem(LocalStorageKeys.IntendedUrl);
};
